// extracted by mini-css-extract-plugin
module.exports = {"question_mark":"Tooltip__question_mark___13eF2"};